import { render, staticRenderFns } from "./dy-to-wx-shop.vue?vue&type=template&id=6ae95681&scoped=true&"
import script from "./dy-to-wx-shop.vue?vue&type=script&lang=js&"
export * from "./dy-to-wx-shop.vue?vue&type=script&lang=js&"
import style0 from "./dy-to-wx-shop.vue?vue&type=style&index=0&id=6ae95681&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae95681",
  null
  
)

export default component.exports